/**
 * Initialize Main Banner Splide Sliders
 */
function initMainBannerSliders() {
  const sliderSections = document.querySelectorAll('.main-banner-slider');
  if (sliderSections.length === 0) return;

  sliderSections.forEach(section => {
    const sliderEl = section.querySelector('.splide');
    if (!sliderEl) return;

    if (typeof Splide !== 'undefined') {
      const options = {
        type: 'fade',
        perPage: 1,
        autoplay: true,
        interval: 5000,
        speed: 1000,
        arrows: true,
        pagination: false,
        rewind: true
      };

      // Safeguard against duplicate initializations
      if (sliderEl.splide) {
        sliderEl.splide.destroy(true);
      }

      // Initialize and mount Splide instance
      const splideInstance = new Splide(sliderEl, options).mount();

      // Theme Editor: Jump to slide when clicking its block in the sidebar
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function(event) {
          if (event.detail.sectionId === section.id.replace('section-', '')) {
            const blocks = Array.from(sliderEl.querySelectorAll('.splide__slide'));
            const targetIndex = blocks.indexOf(event.target);
            if (targetIndex > -1) {
              splideInstance.go(targetIndex);
            }
          }
        });
      }
    } else {
      console.warn("Splide.js is not loaded on this page.");
    }
  });
}

/**
 * Initialize Client Reviews Splide Sliders
 */
function initClientSliders() {
  const sliders = document.querySelectorAll('.client-slider:not(.is-initialized)');
  if (sliders.length === 0) return;

  sliders.forEach(slider => {
    if (typeof Splide !== 'undefined') {
      const splide = new Splide(slider, {
        type   : 'loop',
        perPage: 1,
        perMove: 1,
        gap    : '42px',
        pagination: false,
        breakpoints: {
          767: {
            gap: '24px',
          }
        }
      });

      splide.mount();
      slider.classList.add('is-initialized');

      // Listener to handle instant snapping in the Shopify Theme Editor
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function (event) {
          const blockSlide = event.target.closest('.splide_slide');
          if (blockSlide && slider.contains(blockSlide)) {
            const slidesArray = Array.from(slider.querySelectorAll('.splide_slide'));
            const slideIndex = slidesArray.indexOf(blockSlide);
            
            if (slideIndex !== -1) {
              splide.go(slideIndex);
            }
          }
        });
      }
    } else {
      console.warn("Splide.js is not loaded on this page.");
    }
  });
}

// Run functions on standard page load
document.addEventListener('DOMContentLoaded', function() {
  initMainBannerSliders();
  initClientSliders(); // <-- FIXED: Added this here so it triggers on page load too!
});

// Theme Editor: Re-run when sections are modified, added, or reordered
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section-main-banner-slider')) {
      initMainBannerSliders();
    }

    if (event.target.querySelector('.client-slider') || event.target.classList.contains('client-reviews-section')) {
      // Clear out the initialization helper class if present in the re-rendered wrapper
      const reRenderedSlider = event.target.querySelector('.client-slider');
      if (reRenderedSlider) {
        reRenderedSlider.classList.remove('is-initialized');
      }
      initClientSliders();
    }
  });
}


document.addEventListener('DOMContentLoaded', function () {
    var WORD_LIMIT = 20;

    document.querySelectorAll('[data-description-content]').forEach(function (content) {
      var fullHTML = content.innerHTML;
      var toggle = content.nextElementSibling;

      // Count words from plain text
      var plainText = content.textContent.trim();
      var words = plainText.split(/\s+/);

      if (words.length <= WORD_LIMIT) return; // no truncation needed

      // Walk text nodes and cut off after WORD_LIMIT words, preserving HTML structure
      function truncateNode(root, limit) {
        var count = 0;
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          var wordsInNode = node.textContent.trim().split(/\s+/).filter(Boolean);
          if (count + wordsInNode.length >= limit) {
            var remaining = limit - count;
            var truncatedWords = node.textContent.trim().split(/\s+/).slice(0, remaining);
            node.textContent = truncatedWords.join(' ') + '…';

            // Remove everything after this node
            var current = node;
            while (current) {
              var next = current.nextSibling;
              if (!next) {
                current = current.parentNode;
                if (current === root) break;
                continue;
              }
              current.parentNode.removeChild(next);
            }
            break;
          }
          count += wordsInNode.length;
        }
      }

      var truncatedWrapper = document.createElement('div');
      truncatedWrapper.innerHTML = fullHTML;
      truncateNode(truncatedWrapper, WORD_LIMIT);

      content.innerHTML = truncatedWrapper.innerHTML;
      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        content.innerHTML = expanded ? truncatedWrapper.innerHTML : fullHTML;
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? 'Read more' : 'Read less';
      });
    });
  });